package com.patronat.top.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
sealed interface AuthResponse

@Serializable
@SerialName("success")
data class AuthSuccessResponse(
    val userRole: UserRole,
    val accessToken: String,
    val refreshToken: String
) : AuthResponse

@Serializable
@SerialName("action_required")
data class AuthActionResponse(
    val nextStep: AuthMethod,
    val isOtpSent: Boolean,
    val message: String? = null
) : AuthResponse
